<app-loading-container [loading]="!review">
    <ng-container *ngIf="showBack">
        <a app-button [appearance]="buttonAppearance.Link" [href]="overviewRouterLink" icon="chevron_left">{{
            'REVIEWS.BACK_TO_OVERVIEW' | translate
        }}</a>
    </ng-container>

    <ui-review *ngIf="review" [review]="review"></ui-review>
</app-loading-container>
